'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('.toggle-newsletter', this).click(function () {
        var $this = (0, _jquery2.default)(this);
        var isActive = $this.is(':checked');

        newsletterService.set(isActive).done(function () {
            _notify2.default.success(Resx.App.SuccessfullySaved);
        }).fail(function (result) {
            _notify2.default.error(result.responseJSON.error.message || Resx.App.ErrorsWhileSaving);
        });
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var newsletterService = abp.services.api.newsletter;

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/newsletter.js
// module id = 1180
// module chunks = 0